import { t } from "ttag";

export const SEARCH_DEBOUNCE_DURATION = 300;

export const DEFAULT_SEARCH_LIMIT = 50;

// eslint-disable-next-line ttag/no-module-declaration -- see metabase#55045
export const NULL_DISPLAY_VALUE = t`(empty)`;
